import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/33oSWRhJnJ1F5i8qh6Fx9H/Screenshot_9-3-2026_134257_www.instagram.com.jpg',
  alt: 'Clean fade with textured top and beard'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9sDxpwxyA5hzNmHenxek2f/Screenshot_9-3-2026_134530_www.instagram.com.jpg',
  alt: 'Sharp fade with line detail'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/9kSzMRnWgCngKytndDbk7J/Screenshot_9-3-2026_134023_www.instagram.com.jpg',
  alt: 'Design fade with man bun'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tZWMWvPEeKgzsAdm9Dnkv5/Screenshot_9-3-2026_134133_www.instagram.com.jpg',
  alt: 'Classic slick back with beard trim'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8FcEQ6vuZPsCQmDhUqVArr/Screenshot_9-3-2026_13467_www.instagram.com.jpg',
  alt: 'Clean fade with cross design'
}];
export function GallerySection() {
  const {
    t
  } = useLanguage();
  const doubled = [...galleryImages, ...galleryImages];
  return <div className="my-12" data-id="element-30">
      <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-bold mb-10 text-center" data-id="element-31">
        {t.gallery.heading}
      </h2>
      <div className="overflow-hidden" data-id="element-32">
        <div className="carousel-track-left flex gap-3 w-max" data-id="element-33">
          {doubled.map((image, index) => <div key={index} className="flex-shrink-0 w-[280px] md:w-[350px] overflow-hidden border border-[#c9a84c]/30" data-id="element-34">
              <img src={image.src} alt={image.alt} className="w-full h-auto" data-id="element-35" />
            </div>)}
        </div>
      </div>
    </div>;
}